<script>
import countlyVue from '../../compat/vue-core';

export default countlyVue.components.BaseComponent.extend({
  props: {
    name: {
      default: '',
      type: String,
    },
    src: {
      default: '',
      type: [String, Object],
    },
    size: {
      default: 'large',
      type: String,
    },
    circle: {
      default: false,
      type: Boolean,
    },
    noShadow: {
      default: false,
      type: Boolean,
    },
    bordered: {
      default: false,
      type: Boolean,
    },
    isGoogleUser: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    hasImage() {
      return this.src;
    },
    imagePath() {
      if (this.isGoogleUser) {
        return `${this.src}`;
      }
      if (typeof this.src === 'string') {
        return `/static/${this.src}`;
      }
      return this.src.path;
    },
    initials() {
      return this.name.split(' ').map((l) => l[0]).join('').toUpperCase()
        .substring(0, 2);
    },
    classes() {
      const c = [`cly-avatar--${this.size}`];
      if (this.circle) {
        c.push('cly-avatar--circle');
      }
      return c;
    },
  },
});
</script>

<template>
  <div
    class="cly-avatar flex justify-center w-full"
    :class="classes"
  >
    <div
      v-if="hasImage"
      class="cly-avatar__inner"
      :style="{'background-image': 'url(' + imagePath + ')'}"
    />
    <div
      v-else
      :class="{ 'shadow-md': !noShadow, 'border border-black': bordered }"
      class="cly-avatar__inner cly-avatar__inner--empty flex flex-col justify-center items-center color-white text-3xl"
    >
      {{ initials }}
    </div>
  </div>
</template>

<style scoped lang="scss">
    .cly-avatar.cly-avatar--large {
        .cly-avatar__inner {
            border-radius: 28px;
            width: 100px;
            height: 100px;
            font-size: 50px;
        }
    }

    .cly-avatar.cly-avatar--small {
        .cly-avatar__inner {
            border-radius: 14px;
            width: 50px;
            height: 50px;
            font-size: 25px;
        }
    }

    .cly-avatar.cly-avatar--xsmall {
        .cly-avatar__inner {
            border-radius: 7px;
            width: 25px;
            height: 25px;
            font-size:12px;
        }
    }
    .cly-avatar.cly-avatar--large.cly-avatar--circle {
        .cly-avatar__inner {
            border-radius: 50px;
        }
    }
    .cly-avatar.cly-avatar--small.cly-avatar--circle {
        .cly-avatar__inner {
            border-radius: 25px;
        }
    }
    .cly-avatar.cly-avatar--xsmall.cly-avatar--circle {
        .cly-avatar__inner {
            border-radius: 12.5px;
        }
    }
    .cly-avatar__inner {
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
    }
    .cly-avatar__inner--empty {
        background-color: #7710C9;
    }
</style>
